import React from "react";

// Deeplink-only inline success card shown after the customer updates a field
// during a required profile review. Return resumes the original deeplink.
const ProfileUpdateSuccess = ({ onReturn }) => (
  <div style={{ padding: "16px 16px 0" }}>
    <div
      style={{
        backgroundColor: "#262626",
        borderRadius: "12px",
        padding: "16px",
        boxShadow: "0 6px 16px rgba(0, 0, 0, 0.2)",
      }}
    >
      <p
        style={{
          color: "#fff",
          fontFamily: "FSElliotPro",
          fontSize: "14px",
          fontWeight: 400,
          lineHeight: 1.5,
          margin: 0,
        }}
      >
        Your profile has been updated successfully. You may continue reviewing
        and updating your profile, or return to the page you originally
        requested.
      </p>
      <div style={{ textAlign: "right", marginTop: "12px" }}>
        <span
          onClick={onReturn}
          style={{
            color: "#4DA3FF",
            fontFamily: "FSElliotPro",
            fontSize: "16px",
            fontWeight: 700,
            cursor: "pointer",
          }}
        >
          Return
        </span>
      </div>
    </div>
  </div>
);

export default ProfileUpdateSuccess;
